var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M404.41,134.7a35.75,35.75,0,1,1-35.36-41v35.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.07,122.18a35,35,0,0,1-.39,5.25l-35.35-5.25V86.44a35.71,35.71,0,0,1,35.74,35.74Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 372.92,
    y: 142.15,
    width: 38.01,
    height: 1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.6,145.82a3.17,3.17,0,1,1,3.16-3.17A3.16,3.16,0,0,1,413.6,145.82Zm0-5.33a2.17,2.17,0,1,0,2.16,2.16A2.16,2.16,0,0,0,413.6,140.49Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.26,
    y: 140.65,
    width: 29.53,
    height: 1.33,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.26,
    y: 143.32,
    width: 16.71,
    height: 1.33,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.76,
    y: 210.76,
    width: 9.43,
    height: 67.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.97,
    y: 227.01,
    width: 9.43,
    height: 50.86,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.18,
    y: 252.43,
    width: 9.43,
    height: 25.43,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.38,
    y: 237.91,
    width: 9.43,
    height: 39.95,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119.59,
    y: 222.66,
    width: 9.43,
    height: 55.21,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.8,
    y: 213.69,
    width: 9.43,
    height: 64.18,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.29,202.23l.11,18.91.06,18.91.07,37.81-.24-.23q13,0,26,0l26,.05,26,.05,26,.14-26,.14-26,.06-26,.05q-13,0-26,0h-.23v-.24l.07-37.81,0-18.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,206a7.11,7.11,0,0,1,2.08-.26,7,7,0,0,1,2.08.26,7.38,7.38,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,206Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,211.77a7.48,7.48,0,0,1,2.08-.27,7.38,7.38,0,0,1,2.08.27,7.38,7.38,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,211.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,217.52a7.48,7.48,0,0,1,2.08-.27,7.38,7.38,0,0,1,2.08.27,7.38,7.38,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,217.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,223.27a7.48,7.48,0,0,1,2.08-.27,7.38,7.38,0,0,1,2.08.27,7,7,0,0,1-2.08.26A7.11,7.11,0,0,1,47.21,223.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,229a7.48,7.48,0,0,1,2.08-.27,7,7,0,0,1,2.08.27,7.37,7.37,0,0,1-2.08.26A7.46,7.46,0,0,1,47.21,229Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,234.76a7.11,7.11,0,0,1,2.08-.26,7,7,0,0,1,2.08.26,7.38,7.38,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,234.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,240.51a7.48,7.48,0,0,1,2.08-.27,7.38,7.38,0,0,1,2.08.27,7.38,7.38,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,240.51Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,246.26a7.48,7.48,0,0,1,2.08-.27,7.38,7.38,0,0,1,2.08.27,7.38,7.38,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,246.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,252a7.48,7.48,0,0,1,2.08-.27,7.38,7.38,0,0,1,2.08.27,7,7,0,0,1-2.08.26A7.11,7.11,0,0,1,47.21,252Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,257.76a7.48,7.48,0,0,1,2.08-.27,7,7,0,0,1,2.08.27,7,7,0,0,1-2.08.26A7.46,7.46,0,0,1,47.21,257.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,263.5a7.46,7.46,0,0,1,2.08-.26,7,7,0,0,1,2.08.26,7,7,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,263.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.21,269.25a7.48,7.48,0,0,1,2.08-.27,7.38,7.38,0,0,1,2.08.27,7.38,7.38,0,0,1-2.08.27A7.48,7.48,0,0,1,47.21,269.25Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-2--inject-109"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.7,
    y: 316.51,
    width: 54.69,
    height: 117.88,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.7,
    y: 316.51,
    width: 54.69,
    height: 117.88,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.18,
    y: 316.51,
    width: 16.21,
    height: 117.88,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.48,
    y: 227.15,
    width: 54.68,
    height: 207.24,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.48,
    y: 227.15,
    width: 54.68,
    height: 207.24,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.96,
    y: 227.15,
    width: 16.21,
    height: 207.24,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.27,
    y: 294.5,
    width: 54.69,
    height: 139.89,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.27,
    y: 294.5,
    width: 54.69,
    height: 139.89,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.75,
    y: 294.5,
    width: 16.21,
    height: 139.89,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.05,
    y: 180.22,
    width: 54.69,
    height: 254.16,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.05,
    y: 180.22,
    width: 54.69,
    height: 254.16,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.53,
    y: 180.22,
    width: 16.21,
    height: 254.16,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.83,
    y: 221.11,
    width: 54.68,
    height: 213.28,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.83,
    y: 221.11,
    width: 54.68,
    height: 213.28,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.31,
    y: 221.11,
    width: 16.21,
    height: 213.28,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.62,
    y: 144,
    width: 54.69,
    height: 290.39,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.62,
    y: 144,
    width: 54.69,
    height: 290.39,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.1,
    y: 144,
    width: 16.21,
    height: 290.39,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-109"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "118.98 193.01 147.27 193.01 206.87 287.07 178.57 287.07 118.98 193.01",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "118.98 193.01 147.27 193.01 206.87 287.07 178.57 287.07 118.98 193.01",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.76 139.98 300.06 139.98 359.65 234.05 331.36 234.05 271.76 139.98",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "271.76 139.98 300.06 139.98 359.65 234.05 331.36 234.05 271.76 139.98",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.24 193.01 118.94 193.01 40.7 316.51 68.99 316.51 147.24 193.01",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.11 139.98 271.81 139.98 178.62 287.07 206.91 287.07 300.11 139.98",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "452.7 86.95 424.41 86.95 331.22 234.05 359.51 234.05 452.7 86.95",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.84 86.95 459.39 86.95 448.73 67.3 417.84 86.95",
    style: {
      fill: "#009595"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-109"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "459.39 434.39 407.05 434.63 354.7 434.72 250 434.88 145.3 434.72 92.95 434.63 40.6 434.39 92.95 434.14 145.3 434.05 250 433.89 354.7 434.06 407.05 434.14 459.39 434.39",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.92,246.89c-19.91,16.41-71.65,75.4-74.3,79.47-6.93,10.68-12.92,62.64,18,55.34S250,287.33,260.4,257.82C265.92,242.18,257.17,233.5,240.92,246.89Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.35,376.29c27.79-21,55.82-92.33,65-118.47,3.37-9.53,1.43-16.49-4.28-17.42Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.65,271.75c-3.56-6.63-51.37,12.33-47.51,22.71,14.12,38,34.41,74.17,41.8,81.34,9.69,9.4,24.88,3.95,29.52-4C201.9,360.68,175.18,278.32,171.65,271.75Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.72,302.51c6.09,2.73,38.5-25.29,37-32-1.36-6-2.12-23.88,1.85-36.78,3.32-10.84,9.5-26.55,3.73-28.56-8.39-2.94-18.58,16-23.77,27.21-3.93-5.45-7.83-9.77-11-11.46-10.6-5.6-41.63,38.57-36.77,49.76C110.4,281.49,128.62,299.79,134.72,302.51Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.09,
    y: 204.66,
    width: 9.52,
    height: 41.88,
    transform: "translate(157.62 -43.95) rotate(35.32)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.89 270.47 113.14 262.14 113.14 262.14 134.6 231.85 146.35 240.17 146.35 240.17 124.89 270.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.1,232.84c-.83,6.17-7.63,1.66-7.63,1.66s8.23,8.86,4.91,14.9c-3.22,5.81-11.25.06-11.83-.34.43.47,7.78,8.81,3.82,14.53-4.12,6-11.19-1.2-11.64-1.67.27.58,3.67,8.23-.33,11.89-6.87,6.3-16.11-13-23.33-15.23,0,0-5.14,11.8-5.36,12.11,0,0-9.17-18.2-5.64-27.77a6.5,6.5,0,0,1,6.92-4.3s-3.61-5.54-.63-10.15c1.53-2.36,6.67-2,6.67-2s-2.7-4.56.21-8.49c2.3-3.15,7.1-2.3,7.1-2.3s-.57-5.58,2.83-8C130,202.7,158.87,219.61,157.1,232.84Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.12,215.69a.09.09,0,1,1,.06-.16c10.84,3.24,21.76,10.13,28.68,19.17.23.3-.15.8-.47.52C140.48,227.26,131.93,220.91,121.12,215.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.92,226.32c-.11,0,0-.25.11-.21,11.16,3.41,23.24,11.5,30,22.86.23.39,0,1-.26.55C137.71,242.3,122.68,231,112.92,226.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.93,262.88c-6.9-10.64-16.51-18-27.47-24.15-.14-.08,0-.28.12-.24,6.18,1.54,12.76,6.19,17.57,10.23a33.49,33.49,0,0,1,10.15,13.92C135.38,262.86,135.07,263.11,134.93,262.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.68,234.49c.27.36-.55.36-.29.73,1.1,1.53,6.91,11.33,4.18,14.35-2.18,2.41-6.94,1.14-8.58-.06l-4.12-3,2.82,4.28a21.07,21.07,0,0,1,2.81,6.16c.55,2.15.53,4.43-.61,6.08a4.27,4.27,0,0,1-5,1.89,12.87,12.87,0,0,1-5.37-3.63l-4.15-4.4,2.47,5.49a19.92,19.92,0,0,1,1.47,4.8,8.12,8.12,0,0,1-.4,4.65,3.85,3.85,0,0,1-3.36,2.28,8.59,8.59,0,0,1-4.4-1.82,67.7,67.7,0,0,1-7.76-7.07c-1.26-1.25-2.52-2.5-3.84-3.7a12.49,12.49,0,0,0-4.45-2.91,13.62,13.62,0,0,1,4.1,3.26c1.22,1.28,2.37,2.62,3.53,4a57.4,57.4,0,0,0,7.56,7.64,9.89,9.89,0,0,0,5.2,2.34,5.44,5.44,0,0,0,5.09-3.16,9.87,9.87,0,0,0,.65-5.76,21.52,21.52,0,0,0-1.56-5.36L134,262.59a15,15,0,0,0,6.3,4.35,6.23,6.23,0,0,0,4.19-.12,7,7,0,0,0,3.15-2.68,9.43,9.43,0,0,0,.77-7.71,22.65,22.65,0,0,0-3.2-6.73l-1.3,1.25c2.13,1.46,7.3,3.46,11.17.14C159.43,246,151.3,236.18,149.68,234.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.47,234.5a12.75,12.75,0,0,0,3.72.9,2.88,2.88,0,0,0,2.67-1.2,5.87,5.87,0,0,0,.64-3.28c-.06-1.26-.19-2.57-.37-3.93a10.11,10.11,0,0,1,1.72,3.75,5.8,5.8,0,0,1-.54,4.43,4.08,4.08,0,0,1-2,1.51,4.28,4.28,0,0,1-2.35.06A6.7,6.7,0,0,1,149.47,234.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.76,281.1,124.06,320s33.92,59.9,50,61.93c10.73,1.35,24.26-1.76,23.76-22.16S177.76,281.1,177.76,281.1Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.68,297.05a80,80,0,0,1,4.53,11.2c1.33,3.79,2.55,7.6,3.62,11.47a179.53,179.53,0,0,1,4.76,23.77c.61,4.48,1,9,1.55,13.47a.08.08,0,1,1-.16,0c-.44-4-1.14-8-1.91-11.9s-1.62-7.93-2.58-11.86c-1.88-7.71-3.9-15.39-6.14-23-.63-2.13-1.28-4.26-2-6.37s-1.46-4.38-2-6.63C182.34,297,182.58,296.87,182.68,297.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.33,297.07c-1.51.84-2.91,1.9-4.32,2.88l-4.39,3c-3,2-5.89,4.1-8.81,6.19-5.84,4.17-11.68,8.32-17.44,12.59-1.59,1.17-3.17,2.35-4.72,3.57s-3.17,2.67-4.81,3.94c-.1.07,0,.21.13.14,1.48-1,3-1.86,4.52-2.85s3-2,4.52-3.08q4.4-3.1,8.75-6.26c5.71-4.15,11.45-8.28,17.07-12.55l4.7-3.59c1.64-1.25,3.38-2.43,4.9-3.82C179.51,297.16,179.43,297,179.33,297.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.92,434.19h83.39c.69-2.68,1.35-5.32,2-7.92.76-3,1.51-5.91,2.23-8.75.16-.64.33-1.27.49-1.9l1.61-6.36c.32-1.26.64-2.49.94-3.72s.64-2.47.94-3.67c.09-.31.16-.63.25-.94s.17-.68.25-1,.21-.83.32-1.24h0l.33-1.28c.21-.8.41-1.59.6-2.36.29-1.15.58-2.27.85-3.35.12-.48.25-1,.36-1.42.2-.76.39-1.5.57-2.23.13-.49.25-1,.36-1.43q.75-2.86,1.38-5.39c.11-.44.22-.87.34-1.3.18-.73.36-1.42.52-2.1.12-.42.23-.84.32-1.24.37-1.43.71-2.74,1-3.9.09-.3.16-.6.24-.88.19-.77.37-1.44.52-2,.06-.25.11-.48.17-.69s.12-.47.17-.67.08-.29.11-.42.11-.4.15-.57,0-.18.06-.25c.13-.5.19-.75.19-.75H246.42s-2.68,9.21-7,24.07l-2.81,9.76C233.81,410.12,230.49,421.68,226.92,434.19Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.66,434.19h2.08q4.63-19.15,9-38.39,1.05-4.68,2.07-9.37c.07-.29.13-.58.19-.87s-.2-.23-.24-.07l-.08.29c-.94,3.35-1.89,6.71-2.8,10.07Q301.57,415,296.66,434.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.05,366.39l3.58,17.93L255.57,399l5,25.07.51,2.57.86,4.28.64,3.24h47.74c.68-2.69,1.36-5.33,2-7.92.76-3,1.51-5.91,2.23-8.75.16-.64.33-1.27.49-1.9l1.61-6.36c.32-1.26.64-2.49.94-3.72s.64-2.47.94-3.67c.09-.31.16-.63.25-.94s.17-.68.25-1,.21-.83.32-1.24h0l.33-1.28c.21-.8.41-1.59.6-2.36.29-1.15.58-2.27.85-3.35.13-.49.25-1,.36-1.42.2-.76.39-1.5.57-2.23.13-.49.25-1,.36-1.43q.75-2.86,1.38-5.39c.11-.44.22-.87.34-1.3.18-.73.36-1.42.52-2.1.12-.42.23-.84.32-1.24.37-1.43.71-2.74,1-3.9.09-.3.16-.6.24-.88.19-.77.37-1.44.52-2,.06-.25.11-.48.17-.69s.12-.47.17-.67.08-.29.11-.42.11-.4.15-.57,0-.18.06-.25c.13-.5.19-.75.19-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,366.35v0c0,.44.33,5.28,1.12,12.67.22,2.15.48,4.52.79,7.06.47,4,1.07,8.42,1.8,13.09,1.24,8.15,2.87,17,5,25.72.75,3.13,1.58,6.23,2.46,9.26l104.78,0c-1.23-16-2.37-30.41-3.26-41.79-1.26-16-2.06-26.05-2.06-26.05l-95.06,0Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.26,376c.11,3.75.27,7.49.52,11.23.25,4,.62,8.08,1.15,12.12,0,.15,0,.29,0,.44q.75,5.67,1.7,11.32c.6,3.51,1,7.29,2.6,10.54a10.3,10.3,0,0,0,2.45,3.3,7.35,7.35,0,0,0,3.35,1.74,4.35,4.35,0,0,0,.63.1h.18a.24.24,0,0,0-.12.23c0,1.25,0,2.53.15,3.78,0,0,0,.11,0,.16.13,1.09.33,2.16.53,3.24h1.8s0,0,0-.06c-.31-1.18-.58-2.38-.87-3.57s-.72-2.41-1-3.65c0-.05-.05-.08-.08-.12a5.57,5.57,0,0,0,5.41-3.39,9.65,9.65,0,0,0,.08-4.92c-.32-2.15-.64-4.29-1-6.44-.61-3.94-1.4-7.84-2.1-11.76-.11-.59-.21-1.2-.32-1.79-1.4-8-2.87-16-4.64-23.86-.06-.33-.14-.66-.21-1s-.4-.16-.38.05c.05.53.11,1.07.17,1.59q.46,4.56,1.09,9.07c.51,3.54.85,7.1,1.35,10.64.17,1.21.34,2.41.52,3.62.81,5.82,1.66,11.65,2.65,17.45.47,2.69,2.15,7.52-1.73,8.36a4,4,0,0,1-2.63-.33,8.27,8.27,0,0,1-3.61-4.56,60,60,0,0,1-2.06-9.7q-.94-5.32-1.69-10.66h0q-.94-6.68-2-13.33c-.34-2.26-.7-4.52-1.06-6.78l-.51-3.14C249.61,375.7,249.26,375.76,249.26,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342,403.84a52.72,52.72,0,0,1-12.93-1.74c-1.95-.5-3.87-1.12-5.78-1.75a14.93,14.93,0,0,1-5.22-2.62c-2.94-2.53-4.31-6.52-5.58-10.07a95.76,95.76,0,0,1-3.39-12.22c0-.21-.34-.14-.35.05a47.48,47.48,0,0,0,1.76,13.88c1.05,3.83,2.47,8.11,5.57,10.8,3.25,2.82,7.68,3.81,11.84,4.33a54.48,54.48,0,0,0,14.09-.2A.23.23,0,0,0,342,403.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.25,375.56q.35,8.79.74,17.61.9,20.5,2,41h2q-1.35-20.55-2.85-41.09-.65-8.78-1.33-17.55A.25.25,0,0,0,349.25,375.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,409.76,369.15,399S342.22,293.12,288.32,237c-12.43-12.94-27.2-3.57-34.32,4.39C235.93,261.64,230.57,409.31,231,409.76Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,387.62l-134.59,9.27q.13-3,.31-6.68L364,381.11C364.7,383.49,365.37,385.67,366,387.62Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.16,375.45l-130.21,9q.18-3.19.37-6.68L360,369Q361.16,372.36,362.16,375.45Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,250.33c29.08,38.37,77.63,138.35,84.77,153,4.84,10-48.26,36.27-50.51,29-2.89-9.3-50.38-132-57-176.71C276.57,231.17,292.9,237.06,303,250.33Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.79,427.39c1.24,9.05,7.49,27.26,12.15,30s29.09,2.19,41.41,2.19,14.75-3.38,14.54-7.54-26.05-5-26.05-5,34.53,9.72,43.21,11.31,28.69,6.54,31.58-.53c1.31-3.19-4.17-6.42-4.17-6.42s8.4,2.41,9.73-1.69c1.52-4.66-5.15-7.23-5.15-7.23s5.24,1,5.37-2.76c.26-8.5-32.57-12.68-32.57-12.68s25.14,12,26,5.09c1.12-9.6-50.41-20.12-55.77-24.3a99.78,99.78,0,0,1-10.92-10.42Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.71,454.18a3.68,3.68,0,0,0-1.17-3.24,10.73,10.73,0,0,0-3-1.91,41.5,41.5,0,0,0-7.06-2.25c-4.86-1.21-9.83-2.07-14.79-3.32a61,61,0,0,1,15.21,1.68,28.33,28.33,0,0,1,7.26,2.72,9.94,9.94,0,0,1,3,2.56A3.81,3.81,0,0,1,403.71,454.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.46,451.47c-3.55-.85-7-1.83-10.55-2.83s-7-2-10.44-3.07l-10.4-3.2c-3.47-1.07-6.94-2.12-10.44-3.15a82,82,0,0,1,10.79,1.89c3.56.8,7.07,1.8,10.55,2.84s6.95,2.19,10.36,3.46S445.14,450,448.46,451.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,430.75a71.16,71.16,0,0,1,10,1.35,93.84,93.84,0,0,1,9.74,2.47A87.16,87.16,0,0,1,444.1,438a72.7,72.7,0,0,1,8.94,4.52c-3.18-1.08-6.27-2.27-9.43-3.31s-6.28-2.1-9.46-3.05-6.35-1.9-9.54-2.82S418.2,431.61,415,430.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.05,422.66A62.64,62.64,0,0,1,435.9,426a61.55,61.55,0,0,1,14.58,6.93c-5.1-1.78-10.06-3.67-15.14-5.33S425.2,424.29,420.05,422.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392,400.12l-61.93,25.23s-47.91-133.92-52.29-164.53,4.38-35.53,25.66-11.31S392,400.12,392,400.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.57,388.5c-1.65.47-3.26,1.17-4.87,1.78l-5,1.88c-3.36,1.27-6.7,2.6-10,3.94-6.66,2.68-13.32,5.34-19.92,8.13-1.82.77-3.63,1.54-5.43,2.35s-3.71,1.85-5.59,2.7c-.12.05,0,.22.08.17,1.67-.61,3.39-1.09,5.07-1.7s3.42-1.27,5.11-1.94q5-2,10-4c6.53-2.69,13.07-5.35,19.54-8.18l5.41-2.38c1.89-.82,3.87-1.57,5.67-2.56A.1.1,0,0,0,381.57,388.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.84,407.78q-6.07-15.86-11.69-31.88c-3.77-10.67-7.4-21.39-11-32.13s-7-21.52-10.29-32.35-6.44-21.72-9.08-32.73l2.58,8.09,2.65,8.06L292.37,311l10.7,32.2c3.54,10.74,7.09,21.48,10.56,32.25S320.52,397,323.84,407.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286,293.12a10.55,10.55,0,0,1-1.86-2.09,19.74,19.74,0,0,1-1.43-2.38,18.93,18.93,0,0,1-1.81-5.24,25.27,25.27,0,0,1,1.43,2.37c.45.8.85,1.61,1.27,2.42C284.39,289.82,285.18,291.43,286,293.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.18,200.31s-.38,8.63.39,11.62,7.51,6.13,7.51,6.13-7.67,2.72-9.85,2.2-5.7-6.11-5.7-6.11,3.24,8.95,6.36,9.42c1.93.29-4.75.36-4.75.36a9,9,0,0,1-5.84-2.71C266,218.65,280.18,200.31,280.18,200.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.36,261.12c8.29-.07,18.81-15.33,21.74-26.32.2-.75-9.08-26.65-10.39-32-.26-1.1-31.44,16.3-31.44,16.3s6,10.35,8.24,19.65C245.69,239.56,249.35,261.18,257.36,261.12Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.27,219.13s6,10.35,8.25,19.65c0,.18.27,1.53.71,3.49,15.53-5.36,23.25-17.59,26.83-25.9-2-5.87-3.82-11.39-4.34-13.54C268.44,201.74,237.27,219.13,237.27,219.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.75,166.52c3.93,12.12-1.93,47.44-10.48,55.43-12.39,11.58-33,13-42.91-1.94-9.63-14.48-1.18-60.37,8.4-67.66C248.86,141.61,274,148.61,279.75,166.52Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.07,186.74a28.11,28.11,0,0,0,3.17-.31,5.12,5.12,0,0,0,3.17-.93,1.63,1.63,0,0,0,.22-2c-.89-1.28-2.42-1.49-3.89-1.39a6,6,0,0,0-4,1.69A1.75,1.75,0,0,0,247.07,186.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.4,186.36c0-.09-.21.08-.22.18-.32,2.39-1.09,5.08-3.38,5.51-.07,0-.08.14,0,.14C232.49,192.26,233.48,188.68,233.4,186.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.68,183.52c-3.78-.93-5.35,6.71-1.85,7.56S234.85,184.3,231.68,183.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.18,177.09a30.52,30.52,0,0,0,3.17.41,5.13,5.13,0,0,0,3.31-.19,1.63,1.63,0,0,0,.67-1.9c-.57-1.45-2-2-3.48-2.24a6,6,0,0,0-4.26.75A1.76,1.76,0,0,0,229.18,177.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.44,210.76c-.67.47-1.36,1.14-2.24,1.07a6.41,6.41,0,0,1-2.46-1,.08.08,0,0,0-.12.1,3.24,3.24,0,0,0,2.81,1.8,2.58,2.58,0,0,0,2.22-1.8C246.71,210.78,246.53,210.7,246.44,210.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.12,203.22a8.26,8.26,0,0,1-6,2.71,10.47,10.47,0,0,1-2.94-.35,3.19,3.19,0,0,1-.55-.16l-.51-.17a.59.59,0,0,1-.39-.61v0a.77.77,0,0,1,.06-.24h0l0-.21c.25-1.84.89-4.6.89-4.6-.72.22-4.39,1.19-4.18.24,1.79-7.85,3.78-16.58,7.22-24a.22.22,0,0,1,.42.14c-1.42,7.61-4.17,14.92-5.72,22.55a14.5,14.5,0,0,1,4-.53c.25.12-1.33,5.31-1.38,6.15v.09c3,.91,5.5.36,8.83-1.21C245.13,202.86,245.29,203.05,245.12,203.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.29,189.16a8,8,0,0,0-2.16-.69,8.25,8.25,0,0,0-2.33-.05,6.44,6.44,0,0,0-2.32.78,5.63,5.63,0,0,0-1.82,1.75l-.84,1.29,1.55,0a16,16,0,0,1,3.28.27,6.73,6.73,0,0,1,3.08,1.35,4.9,4.9,0,0,0-2.71-2.5,9.52,9.52,0,0,0-3.71-.74l.71,1.26a5.56,5.56,0,0,1,3.06-2.08A17,17,0,0,1,254.29,189.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.4,194.91a13.56,13.56,0,0,1-3.22-1.52c-.23-.18-1.11-.94-1-1.13a6.48,6.48,0,0,1,.73-1.6,4.6,4.6,0,0,0-1.08,1.53,2.31,2.31,0,0,0,1.09,1.63A7,7,0,0,0,249.4,194.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.17,199.77c-6.36-2.44-7.72-24.63-7.72-24.63l-2.33,11.92A29.08,29.08,0,0,1,262.59,177c-1.34-4-.34-9.35.52-11.94,0,0-8.21,5.37-16.75,6.82-3.14.54-23-.85-22.9-2.26.37-4.18,7.7-17.95,13.73-21.31,6.94-3.87,22.85-8.39,35.89-2,10.43,5.1,8.64,13.36,10.48,19.41,0,0,7.29,7,7.39,10.27C291.15,183,281.51,200.67,279.17,199.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,202.18a10.21,10.21,0,0,1-6.25-13h0a10.2,10.2,0,1,1,8.73,13.53A9.91,9.91,0,0,1,247,202.18Zm-5-12.55a8.84,8.84,0,1,0,11.27-5.42,9.1,9.1,0,0,0-2.15-.47A8.88,8.88,0,0,0,242,189.63Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.36,197.83c-4.14-.65-6.79-5.7-5.92-11.26a12.24,12.24,0,0,1,3.24-6.71,6.34,6.34,0,0,1,10.74,1.69,12.22,12.22,0,0,1,1,7.38c-.83,5.26-4.53,9.12-8.43,9A4.93,4.93,0,0,1,226.36,197.83Zm-1.72-17a10.81,10.81,0,0,0-2.85,6c-.76,4.82,1.39,9.17,4.78,9.7s6.77-2.95,7.53-7.76a10.81,10.81,0,0,0-.89-6.55,5.43,5.43,0,0,0-3.89-3.15,4.8,4.8,0,0,0-.52-.05A5.62,5.62,0,0,0,224.64,180.82Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.79,190.4l1.07-.84c-1.25-1.59-4.4-4-7.38-1.92l.79,1.11C237.94,186.86,240.68,190.26,240.79,190.4Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.77,202.2l1.31-.36c-.17-.62-1.75-6-4.64-7.12-2.69-1-20.94-3.06-21.72-3.15l-.15,1.36c5.24.58,19.31,2.27,21.39,3.06C282.86,196.72,284.35,200.72,284.77,202.2Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.16,197.12s7.9-11.43,13.09-8.62-.71,19.35-6.77,21.64a6.19,6.19,0,0,1-8.3-3.27Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.44,193.2a.08.08,0,0,1,0,.16c-4.25,1.74-6.47,5.7-8,9.8,1.26-1.58,3-2.46,5.1-1,.11.08,0,.25-.12.23a3.79,3.79,0,0,0-4.17,1.34,18.54,18.54,0,0,0-2,3.39c-.2.38-.89.18-.75-.26l0-.09C273.44,201.38,277.62,193.77,283.44,193.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.79,240.19,256,257.76l21.22-29.24,8.16,6.76S267,278,266.6,276.23l-10.72-15.11-10.59,13.65-1.88-29.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.2,245.56c0-.18.3-.31.32-.1.7,5.41,1.83,24.37,2.21,27.69l.05-.06c.4-.58,10-12.11,10.1-12,2.18,2.38,10,13.28,10.6,14.32,2.71-6.83,14.46-31.45,17.92-38.05a.17.17,0,0,1,.32.12c-2.22,7.1-17.32,40.32-17.62,40.28-.18.18-9.9-13.31-11.24-16-1.39,2.42-10.92,15.22-11,14.5C244.31,272,243.2,250.12,243.2,245.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,201a20.42,20.42,0,0,0,2.94,2.29c.24.16.5.31.76.46s.46.27.7.39l.49.26,7.39,3.64a17.06,17.06,0,0,1-1.95-1.1,18.45,18.45,0,0,1-1.56-1.11c-.47-.36-.93-.76-1.39-1.18-11.22-10.46-10.45-32.23,1.72-48.62,9.38-12.65,22.78-18.41,33.58-15.6a19.57,19.57,0,0,1,3.89,1.44l-7.39-3.65a.08.08,0,0,0-.06,0c-.31-.17-.64-.31-1-.45s-.56-.24-.85-.34l-.39-.14-.66-.22-.38-.11c-6.59-1.93-14.22-.58-21.32,3.62l-1.08.66a44.74,44.74,0,0,0-11.77,11.16C147.55,168.79,146.77,190.56,158,201Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.27,197.2c-12.37,16.66-30.71,23.13-44,16.59l-7.38-3.65c13.23,6.55,31.58.07,44-16.59,14.26-19.23,15.16-44.79,2-57.06a24.22,24.22,0,0,0-3.45-2.68,23.35,23.35,0,0,0-2.28-1.29l7.38,3.64c.78.4,1.55.83,2.3,1.3a24.72,24.72,0,0,1,3.44,2.68C226.44,152.42,225.54,178,211.27,197.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19,206.17a24.89,24.89,0,0,0,3.44,2.68,23.14,23.14,0,0,0,2.8,1.53.18.18,0,0,0,.09,0c.41.19.81.36,1.22.52.25.11.49.19.75.28a26,26,0,0,0,11,1.33c.85-.07,1.7-.18,2.54-.32h0a31.45,31.45,0,0,0,3.85-.89l1.29-.4c.86-.29,1.72-.61,2.56-1s1.73-.75,2.57-1.18,1.7-.89,2.53-1.39a51.71,51.71,0,0,0,15.07-13.84c14.25-19.22,15.16-44.78,2-57.06-.54-.51-1.11-1-1.68-1.43s-1.16-.86-1.76-1.25c-.34-.21-.68-.42-1-.62l-.24-.13c-.28-.17-.58-.32-.87-.47-13.26-6.67-31.69-.2-44.1,16.52C141.92,168.34,141,193.89,154.19,206.17Zm5.53-53.77a44.74,44.74,0,0,1,11.77-11.16l1.08-.66c7.1-4.2,14.73-5.55,21.32-3.62l.38.11.66.22.39.14c.29.1.56.22.85.34s.65.28,1,.45a.08.08,0,0,1,.06,0,18.34,18.34,0,0,1,3.5,2.21,16.89,16.89,0,0,1,1.38,1.18c11.22,10.47,10.46,32.25-1.7,48.64-9.38,12.64-22.79,18.4-33.59,15.58a20.06,20.06,0,0,1-4.37-1.69c-.24-.12-.47-.25-.7-.39s-.52-.3-.76-.46A20.42,20.42,0,0,1,158,201C146.77,190.56,147.55,168.79,159.72,152.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.39,204.67c.46.42.92.82,1.39,1.18,10.8,2.82,24.21-2.94,33.59-15.58,12.16-16.39,12.92-38.17,1.7-48.64a16.89,16.89,0,0,0-1.38-1.18c-10.8-2.81-24.2,3-33.58,15.6C154.94,172.44,154.17,194.21,165.39,204.67Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.45,142.43,206.28,180a48.09,48.09,0,0,0,2.43-7.27l-19.59-32.21A30,30,0,0,0,183.45,142.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,139.84l13,21.41c-.22-7.82-2.84-14.88-7.92-19.62a16.89,16.89,0,0,0-1.38-1.18A21,21,0,0,0,197,139.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.38,144.58l24.5,40.26c.56-1,1.1-2,1.57-3.05l-23.52-38.65C181.08,143.58,180.23,144.05,179.38,144.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.77,179a38.75,38.75,0,0,0-.31,5.12l13.61,22.37a21.6,21.6,0,0,0,3.41,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.23,166.28l22.87,37.57a38.79,38.79,0,0,0,10.13-6.76L168.32,154.5c-.41.5-.81,1-1.21,1.55A50.08,50.08,0,0,0,161.23,166.28Z",
    style: {
      fill: "#ebebeb"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-1--inject-109"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 55.78,
    y: 50.6,
    width: 1,
    height: 46.23,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.28,51.1A3.74,3.74,0,1,1,60,47.36,3.75,3.75,0,0,1,56.28,51.1Zm0-6.48A2.74,2.74,0,1,0,59,47.36,2.74,2.74,0,0,0,56.28,44.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 44.12,
    width: 35.91,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.1,
    y: 47.36,
    width: 20.33,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.56,
    y: 56.59,
    width: 7.73,
    height: 7.73,
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 56.59,
    width: 35.91,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 59.83,
    width: 20.33,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.56,
    y: 72.35,
    width: 7.73,
    height: 7.73,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 72.35,
    width: 35.91,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 75.59,
    width: 20.33,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.56,
    y: 88.12,
    width: 7.73,
    height: 7.73,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 88.12,
    width: 35.91,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 91.36,
    width: 20.33,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.56,
    y: 103.88,
    width: 7.73,
    height: 7.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 103.88,
    width: 35.91,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.22,
    y: 107.12,
    width: 20.33,
    height: 1.62,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.49,124.52l.15,0,.14,0,2.79-1,.17,0,1.59-.56.19-.06,2.53-.88.2-.08,1.55-.54.23-.07h0l2.91-1,.24-.08,1.75-.61.27-.09,2.18-.76.29-.1,1.91-.67.31-.1,2.64-.92.27-.1,2-.7.26-.09,1.93-.67.23-.08,2.2-.77.21-.08,1.91-.66.19-.06,2.68-.94.2-.06,2.82-1,.15-.06,2.16-.75.14,0,2.8-1,.12,0,2.36-.82.11,0,2.47-.86-2.35-.76-.1,0-2.72-.87-.12,0-2.33-.75-.13,0-3-1-.17,0-2-.64-.18-.06-4.37-1.41-.22-.07L72,102l-.23-.07-4.27-1.38-.26-.08h0l-.94-.3-.28-.08L61.64,98.7h0l-.34-.1-1-.32-.32-.1-4.61-1.49-.34-.1-.53-.17-.32-.11-5.08-1.63-.3-.1h0l-.46-.15-.27-.08L43,92.71c0,.14-.09.28-.13.43h0c0,.12-.08.24-.11.36h0l0,.1h0c-.05.14-.09.29-.13.43a53,53,0,0,0-1.85,11h0l0,.45h0a45.84,45.84,0,0,0,0,5.11c0,.33,0,.65.06,1v0A54,54,0,0,0,43.49,124.52Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4,107.3l-.12,1.62-.11,0,.13-1.69Zm-2.94-.94.23,3.46.12,0-.23-3.38Zm-2.71,4.49.14,0,.24-5.19-.13,0Zm-2.89-6.29.58,7.1.15-.06-.56-7Zm-2.44,8.14.2-.06.25-8.72-.18-.06Zm-4.1-10.25-.22-.07.74,5.76.71,5.56.19-.06L74,108.11Zm-.89,12,.21-.08L72,102l-.23-.07Zm-4.92-13.86-.26-.08L70,115.29l.23-.08ZM66,100.11l1.78,15.94.26-.09-1.76-15.77Zm-4.39-1.42-.34-.1,4.23,18.26.27-.1-4.16-18ZM60,98.17l2.58,19.7.31-.1-2.57-19.5Zm-5-1.59,5.33,22.06.29-.1L55.39,96.68Zm-.85-.28,3.73,23.19.27-.09-3.68-23Zm-5.38-1.73,7.12,25.61.24-.08L49.12,94.67Zm-.73-.23,4.71,26.93.23-.07h0L48.36,94.42Zm-5.29-.83,8.25,28.38.2-.08L42.91,93.14c0,.12-.08.24-.11.36Zm-.16.54,5.69,28.78.19-.06L42.77,93.62C42.72,93.76,42.68,93.91,42.64,94.05ZM40.76,105.5l5.81,17.94.17,0-6-18.34,0,.45Zm.08,6.09v0l2.8,12.86.14,0-3-13.81C40.79,110.94,40.81,111.26,40.84,111.59Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.49 124.52 47.5 124.09 94.75 107.63 90.75 108.06 43.49 124.52",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.75 108.06 94.75 107.63 47.04 92.28 43.03 92.71 90.75 108.06",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.18,56.61l.33,51.48L69.19,92.49C76,70.82,94.77,56.76,117.18,56.61Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.86,56.63l1.32,2.24v.3l-1.5-2.53Zm-1.87.1,3.23,7.18v-.4l-3-6.8Zm-5.61.67L117.27,72V71.6l-8.68-14.23Zm-1.2.23L117.32,79.3v-.51L107.38,57.6A1.2,1.2,0,0,0,107.18,57.63Zm3.4,17.74,6.78,10V85l-6.56-9.71L102.86,63.5l-2.66-3.93a1.7,1.7,0,0,0-.24.09l2.69,4ZM99.36,59.88l18,31.58V90.9L99.6,59.78Zm-6.08,2.78L117.41,94.3v-.48L93.55,62.51Zm-.55.3,24.73,37.86v-.6L93,62.81A1.35,1.35,0,0,1,92.73,63Zm-5.24,3.39,30,36v-.53L87.79,66.14Zm-.61.47,27.41,40.23.59.19L87.17,66.6A2,2,0,0,0,86.88,66.82Zm-4.52,3.9,30.47,35.86.69.22L82.62,70.47A3.07,3.07,0,0,1,82.36,70.72Zm-.49.5,24,33.11.53.17L82.12,71Zm-3.93,4.45,25.31,27.81.62.21L78.13,75.43Zm-.62.82L95.61,101l.46.15L77.51,76.24C77.44,76.32,77.38,76.41,77.32,76.49Zm-3.13,4.7L91.41,99.66l.51.17L74.32,81A1.59,1.59,0,0,0,74.19,81.19Zm-.47.81L86.2,98l.38.12L73.84,81.78A2.18,2.18,0,0,0,73.72,82ZM71.1,87.31l8.44,8.53L80,96l-8.79-8.87A1.67,1.67,0,0,0,71.1,87.31Zm-.46,1.1,5,6.17.32.11-5.26-6.48A1.67,1.67,0,0,0,70.64,88.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.51,108.09l48.32,15.59a50.81,50.81,0,0,1-48,35.9,50.17,50.17,0,0,1-15.69-2.43c-16-5.17-27.47-16.65-32.76-32.84Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.83,123.68l4,0a50.8,50.8,0,0,1-48,35.89l-4,0A50.81,50.81,0,0,0,165.83,123.68Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M165.83,123.68l4,0a50.8,50.8,0,0,1-48,35.89l-4,0A50.81,50.81,0,0,0,165.83,123.68Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M163.65,123l.55,5.16a.14.14,0,0,1,0,.06l-.56-5.23Zm-5.54-1.79,4.06,11.27,0,0-4-11.21Zm-2-.63,2.46,17.67,0-.07-2.46-17.58Zm-3.49-1.13,5.16,19.89,0-.07-5.13-19.78Zm-1.36-.43L154,143.82l.08-.09L151.4,119Zm-4.12-1.33,6,27,.09-.09-6-26.85Zm-1-.33,2.43,31.39.13-.09-2.43-31.26Zm-3.77-1.21-.17-.06,5.64,33.23.13-.1Zm-1.49-.48.43,37.87.17-.1-.43-37.72Zm-4.31-1.39-.22-.08,4.4,39.63.18-.09Zm-1.54,42.12.24-.09.33-42.34-.2-.08Zm-3.7-43.81-.25-.09,3.52,44.06.22-.08ZM129,158.24a2.3,2.3,0,0,0,.28-.06l1.4-45.86-.26-.08Zm-3.45-47.57-.31-.1,3.25,47.79.28-.06Zm-4.88-1.58-.36-.11,1.7,50.4.33,0h0l.33,0,2.14-48.89-.31-.1-2.16,48.93Zm-6,0-.33.1,1.19,50.36.31,0h.35l3.7-50.73-.36-.11-3.66,50.51Zm-5.53,49.78.29.05,4.6-49.62-.33.11Zm.66-48.14-.94,48.09.28,0,.93-48.23Zm-7.66,46.41.08,0,.15,0,7.11-46.38-.29.1ZM102,155l-.16,2.08.24.08.16-2.15.52-6.76,1-13.53,1.71-22.53-.22.08-1.73,22.44-1,13.52Zm-7.37-.88.18.09,9.91-41.75-.24.08Zm4.28-39.7L94,153.77l.18.09,4.87-39.55Zm-10,36.39.13.09,9.22-36.27-.19.06Zm-2.93-32-3.33,27a.43.43,0,0,1,.1.09l3.32-27.14Zm-8,21.83.06.08,7-21.58-.1,0Zm14.71-24.08L88,150.15a.51.51,0,0,0,.13.09l4.62-33.82Zm-9.34,29.89.09.07,5-17.43,3.12-11,.36-1.27-.14,0L91.39,118l-3.12,11ZM81.59,120.2l-4.17,19.66a.56.56,0,0,0,0,.08l4.19-19.76ZM74.76,136a.09.09,0,0,0,0,.06l5.93-15.52-.07,0Zm2.72-14.37-3.35,13.33,0,.06,3.36-13.4Zm-5.93,8.29a0,0,0,0,0,0,0l4.27-7.76h0Zm1.09-6.65-1.82,5s0,0,0,0l1.83-5Zm-3.16,1.34h0a4.44,4.44,0,0,1,.27-.38h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.18,56.61c28-.18,50.84,22.72,51,51.15a49.69,49.69,0,0,1-2.37,15.92l-48.32-15.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.9,83.22l.17.33L117.44,97.79V97.4Zm.3.57L117.48,103v.36L162.36,84.1A3,3,0,0,0,162.2,83.79Zm-44.79,8v.35l41-14.39a1.66,1.66,0,0,0-.22-.3ZM158.63,78l-41.2,18.15v.41l41.39-18.26C158.77,78.18,158.69,78.08,158.63,78Zm-41.31,1.44v.24l31.25-12.24-.21-.17ZM149.25,68,117.35,83.8v.3l32.11-16A1.24,1.24,0,0,0,149.25,68Zm-31.89,17.2v.29l36.42-13.32a2.5,2.5,0,0,0-.23-.23Zm37-12.45L117.4,90.5v.35l37.14-17.92C154.47,72.86,154.4,72.78,154.32,72.71ZM117.24,67v.14l16.07-7.94-.18,0Zm18-7.12-17.93,11V71l18.12-11.1ZM117.28,73.21v.19l24.87-10.3a1.55,1.55,0,0,0-.22-.12Zm26.06-9.41-26,13.93V78l26.22-14.06ZM117.21,61v.1l7.47-4-.15,0Zm10.54-3.34-10.52,7.21V65l10.68-7.32A.76.76,0,0,0,127.75,57.67Zm-10.56.74v.09l2.5-1.84h-.13ZM168,112.66l-20.46,5.13.26.09L168,112.82S168,112.72,168,112.66Zm-27.71,2.79.38.12,27.38-3.66c0-.06,0-.11,0-.17ZM167,119.31l-8.08,2.14.19.06,7.87-2.08A.5.5,0,0,0,167,119.31Zm-12.22.81.28.09,12-1.26a.5.5,0,0,0,0-.12Zm13.37-14.43-31.9,8.45.33.1,31.57-8.35Zm-41.1,5.47.48.16,40.59-6.09a1.48,1.48,0,0,0,0-.21Zm18.59-7.25-20.77,6.55.38.13,20.47-6.45,13.51-4.26L166,97.76l1.12-.35c0-.08,0-.16,0-.25l-1.14.36-6.76,2.13ZM118,108.25l.51.16L167,97.05a2,2,0,0,0-.05-.24ZM165,90.1l-47.46,18,.42.13,47.15-17.84A1.72,1.72,0,0,0,165,90.1Zm-47.53,13.67v.34L165,90a1.45,1.45,0,0,0-.11-.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.18,56.61l4,0c28-.19,50.85,22.71,51,51.14a49.44,49.44,0,0,1-2.38,15.93l-4,0a49.69,49.69,0,0,0,2.37-15.92C168,79.33,145.17,56.43,117.18,56.61Z",
    style: {
      fill: "#37474f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartVector);
export default __webpack_public_path__ + "static/media/chart-vector.eb76905e50c70f68fbb1547b7a6cdd6d.svg";
export { ForwardRef as ReactComponent };